<template>
  <section class="banner">
    <!--工具条-->
    <div v-show="isBanner">
      <el-col :span="24" class="toolbar pad_left">
          <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <p style="margin: 0;margin-left: -22px;" class="goodslist1">
            <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </p>
          <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"></div>
        </div>
          <el-collapse-transition>
          <div style="padding:0 12px" v-show="show3">
        <el-form :inline="true" class="findform" :model="filters" style="margin-top:10px;display:flex">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:100%" label="关键词语：">
            <el-input v-model="filters.name" placeholder="请输入姓名/昵称/手机号"></el-input>
          </el-form-item>
          <el-form-item style="display:flex;width:100%" label="注册时间：" class="sub_chaxun">
            <!-- <el-date-picker type="date" class="normal_width" placeholder="选择日期" v-model="filters.date1" style="width: 100%;" :editable = "false" value-format="yyyy-MM-dd"></el-date-picker>

                    <span class="line till">至</span>

            <el-date-picker placeholder="选择时间" class="normal_width" v-model="filters.date2" style="width: 100%;" :editable = "false" value-format="yyyy-MM-dd" :picker-options="pickerOptions2"></el-date-picker>-->
            <el-date-picker
              :title="value6"
              style="width:100%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
              :editable="iseditable"
              v-model="value6"
              value-format="yyyy-MM-dd"
              @change="changetime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item style="display:flex;width:100%">
            <el-button style="float:right"  @click="onSubmit" class="toolbar_search">查询</el-button>
          </el-form-item>
        </el-form>
         </div>
          </el-collapse-transition>
          </div>
      </el-col>

      <!--列表-->
      <template>
        <el-col :span="24" class="main_container p ad_left">
          <section class="model_section">
            <el-col :span="18" style>
              <p class="model_top_title">平台管家管理</p>
            </el-col>
          </section>
          <div class="table_container">
            <div class="table_inner_container">
              <el-table
                :data="users"
                :header-cell-style="{background:'#bbbbbb'}"
                v-loading="listLoading"
                class="ban_tab"
                stripe
                border
                style="height:auto"
              >
                <el-table-column label="序号"  align="center">
                  <template scope="scope">
                    <span>{{scope.$index + 1}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="NickName" label="昵称" wdith="109" align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.NickName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.NickName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Name" label="姓名"  align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.Name"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.Name}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Phone" label="手机"  align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.Phone"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.Phone}}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="Wechat" label="微信号" width="122" align="center"></el-table-column> -->
                <el-table-column prop="ZoneName" label="区域"  align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.ZoneName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.ZoneName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CityName" label="城市"  align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.CityName"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.CityName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CoNum" label="共创端人数"  align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.CoNum"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.CoNum}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CoPrice" label="总成交额"  align="center">
                  <template scope="scope">
                    <span
                      :title="'￥'+scope.row.CoPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.CoPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="kedanjia" label="客单价" align="center">
                  <template scope="scope">
                    <span
                      :title="'￥'+scope.row.kedanjia"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.kedanjia}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="NoCashPrice" label="未提现金额"  align="center">
                  <template scope="scope">
                    <span
                      :title="'￥'+scope.row.NoCashPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.NoCashPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CashPrice" label="已提现佣金"  align="center">
                  <template scope="scope">
                    <span
                      :title="'￥'+scope.row.CashPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.CashPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CommissionPrice" label="累计佣金"  align="center">
                  <template scope="scope">
                    <span
                      :title="'￥'+scope.row.CommissionPrice"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >￥{{scope.row.CommissionPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="CTime" label="注册时间"  align="center">
                  <template scope="scope">
                    <span
                      :title="scope.row.CTime"
                      style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    >{{scope.row.CTime}}</span>
                  </template>
                </el-table-column>
              </el-table>
                <el-col :span="24" style="padding-top:10px" class="toolbar_footer">
            <el-pagination
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
              :page-size="10"
              :total="total"
              style="float:right;"
            ></el-pagination>
          </el-col>
            </div>
           
          </div>

         
        </el-col>
      </template>
    </div>
  </section>
</template>

<!--分页-->

<script>
import util from "../../common/util";
import NProgress from "nprogress";
import { getUserListPage, removeUser, editUser, addUser } from "../../api/api";
import { butlerlist } from "../../api/api";

export default {
  data() {
    return {
      show3:true,
      iseditable: false,
      value6: "",
      filters: {
        name: "",
        date1: "",
        date2: ""
      },
      users: [],
      total: 100,
      page: 1,
      listLoading: false,
      // banner是否显示
      isBanner: true,
      pageIndex: 1,
      pageSize: 10,
      pickerOptions2: {
        disabledDate: time => {
          let beginDateVal = this.filters.date1;

          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      }
    };
  },
  methods: {
    changetime() {
         if(this.value6+""=="null"){
           this.value6 = ["",""]
      }
      console.log(this.value6);
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getbutlerlist();
    },
    // 重置
    fnReset() {
      this.filters = {
        name: "",
        date1: "",
        date2: ""
      },
      this.value6 = "";
      // this.pageIndex = 1;
      // this.getbutlerlist();
    },
    // 查询按钮
    onSubmit() {
      this.pageIndex = 1;
      this.getbutlerlist();
    },
    //删除
    handleDel: function(row) {
      //console.log(row);
      var _this = this;
      this.$confirm("确认删除该记录吗?", "提示", {
        //type: 'warning'
      }).then(() => {
        _this.listLoading = true;
        NProgress.start();
        let para = {
          id: row.id
        };
        removeUser(para).then(res => {
          _this.listLoading = false;
          NProgress.done();
          this.$swal({
            type:"success",
            text:"删除成功"
          })
          _this.getUsers();
        });
      });
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    getbutlerlist() {
      let that = this;

      // if (this.filters.date1 != "") {
      //   var date1 =
      //     this.filters.date1.getFullYear() +
      //     "-" +
      //     this.p(this.filters.date1.getMonth() + 1) +
      //     "-" +
      //     this.p(this.filters.date1.getDate());
      // } else {
      //   var date1 = "";
      // }

      // if (this.filters.date2 != "") {
      //   var date2 =
      //     this.filters.date2.getFullYear() +
      //     "-" +
      //     this.p(this.filters.date2.getMonth() + 1) +
      //     "-" +
      //     this.p(this.filters.date2.getDate());
      // } else {
      //   var date2 = "";
      // }

      var loginParams = {
        key: this.filters.name,
        userId: localStorage.Id,
        startTime: this.filters.date1,
        endTime: this.filters.date2,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      butlerlist(loginParams)
        .then(data => {
          this.total = data.RowsCount;
          data = data.ResultObj;
          for (var obj of data) {
            console.log(obj);
            if (obj.CoNum == 0) {
              obj.kedanjia = 0;
            } else {
              let keprice = Number(obj.CoPrice) / Number(obj.CoNum);
              keprice = parseInt(keprice);
              console.log(keprice);
              obj.kedanjia = keprice;
            }
          }

          this.users = data;
          console.log(this.users);
        })
        .catch(err => {
          this.users = [];
        });
    }
  },
  mounted() {
    this.getbutlerlist();
    // this.getUsers();
  }
};
</script>
<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
}
.banner .toolbar {
  height: auto;
}

/* 时间  */
/* .toolbar .line {
  margin-left: 20px;
  line-height: 36px;
} */
/* 时间图标 */
/* .toolbar .line img{
  margin-top:8px
} */
.toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
}

/* 内容表格 */
.banner_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  height: 640px;
  position: relative;
  /* overflow: hidden;
   */
}

/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}

.banner_table .el-col-22 p {
  width: 86px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}

/* 新增按钮 */
.banner_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}

/* 表格 */
.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}

/* 表格操作 */
.ban_tab p {
  float: left;
  color: #b2b2b2;
  width: 30%;
}

/* .ban_tab p img{
  margin-top:10px
} */
.ban_tab p:first-child {
  margin-left: 10%;
}

/* 新增页面 */
.add_banner {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  height: 801px;
  position: relative;
}

.add_banner .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.add_banner .el-col-24 p {
  width: 110px;
  height: 55px;

  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  margin-left: 20px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
.add_banner input {
  border: 1px solid #f2f2f2;
  background: #fff !important;
}
</style>


// WEBPACK FOOTER //
// butler.vue?10b4112e